import http from '@/utils/http'

export const loadServices = (nodeID) => http.get(`/kuiper/${nodeID}/services`)

export const loadService = (nodeID, name) => http.get(`/kuiper/${nodeID}/services/${name}`)

export const registerService = (nodeID, body = {}) => http.post(`/kuiper/${nodeID}/services`, body)

export const updateService = (nodeID, name, body = {}) => http.put(`/kuiper/${nodeID}/services/${name}`, body)

export const deleteService = (nodeID, name) => http.delete(`/kuiper/${nodeID}/services/${name}`)

export const loadServicesFuncs = (nodeID) => http.get(`/kuiper/${nodeID}/services/functions`)

export default {}
